import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
import '../../microservice/container/sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import Sidebar from '../../container/Sidebar/Sidebar';
import { useTranslation } from "react-i18next";
import '../../Style/defaultstyle.scss'
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;
// Titlecloudcompute
function MSA2ENG() {
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col lg={3} md={12} xs={12}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col lg={9} md={12} xs={12} className="right-content">
                        {/* {Titlecloudcompute("한비로 마이크로서비스 기반 개발이란")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">CQRS</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>Command and Query Responsibility Segregation (CQRS)</p>
                            <p class='typo-14'>• Command: Operations that modify data (Create, Update, Delete)</p>
                            <p class='typo-14'>• Query: Operations that retrieve data (Read)</p>
                            <p class='typo-14'>• CQRS: The separation of responsibilities between commands and queries</p>
                            ` }}></BoxText>

                            <Image src="https://www.hanbiro.com/msa/images/cqrs.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">EventSourcing</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>All events that occur sequentially are stored in the order they are applied.</p>
                            <p class='typo-14'>Update or delete operations on events are not performed. </p>
                            <p class='typo-14'>Event sourcing offers excellent scalability and a distributed approach to handling changes.</p>
                            ` }}></BoxText>

                            <Image src="https://www.hanbiro.com/msa/images/event-source.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">API Gateway</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>Microservices communicate through APIs.</p>
                            <p class='typo-14'>By URL: Routes are distinguished by URLs, such as a.vora.net and b.vora.net.</p>
                            <p class='typo-14'>By Module (Prefix/Host based): Routes are distinguished by path prefixes, such as a.vora.net/a and a.vora.net/b. </p>
                            <p class='typo-14'>Manages endpoints and REST APIs of multiple services. </p>
                            ` }}></BoxText>

                            <Image src="https://www.hanbiro.com/msa/images/api-gateway.png"></Image>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Containers, Docker and Kubernetes</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>A Pod in Kubernetes is smaller and more lightweight than a virtual server, making it well-suited for microservices. </p>
                            ` }}></BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">APIs provided as serverless services</p></BoxTitle>

                            <BoxText dangerouslySetInnerHTML={{
                                __html: `
                            <p class='typo-14'>A Kubernetes Pod is smaller and more lightweight than a virtual server, making it suitable for microservices. </p>
                            <p class='typo-14'>Applications only start when needed. </p>
                            <p class='typo-14'>No cost is incurred during idle time (storage fees may apply depending on the service).</p>
                            <p class='typo-14'>Reduces development time and cost.</p><br>

                            <div style="display: grid; grid-template-columns: auto auto;">
                                <p class='typo-14'>• Identity : OAuth</p>
                                <p class='typo-14'>• Core Storage (S3)</p>
                                <p class='typo-14'>• Directory</p>
                                <p class='typo-14'>• Simple URL Shortner</p>
                                <p class='typo-14'>• IAM (Identity and Access Management)</p>
                                <p class='typo-14'>• Generate QR Code</p>
                                <p class='typo-14'>• Event Sourcing</p>
                                <p class='typo-14'>• Business Process</p>
                                <p class='typo-14'>• Long-running</p>
                                <p class='typo-14'>• Automation Rule</p>
                                <p class='typo-14'>• Messaging :</p>
                                <p class='typo-14'>• Email</p>
                                <p class='typo-14' style="margin-left: 15px">• Topics</p>
                                <p class='typo-14'>• SMS</p>
                                <p class='typo-14' style="margin-left: 15px">• Queues</p>
                                <p class='typo-14'>• DNS</p>
                                <p class='typo-14'style="margin-left: 15px">• Incoming Webhooks</p>
                                <p class='typo-14'>• IOT</p>
                                <p class='typo-14' style="margin-left: 15px">• Outgoing Webhooks</p>
                                <p class='typo-14'>• Search query</p>
                                <p class='typo-14' style="margin-left: 15px">• Scheduler</p>
                                <p class='typo-14'>• Rate Limiting</p>
                            </div>
                            
                            ` }}></BoxText>

                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};


const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const BoxSubText = styled.div`
  margin-left: 7%;
`

const Image = styled.img`
  width: 100%;
`

export default MSA2ENG;